import { ClienteProdutoIntegracoes } from '../../../../../../../types/cliente-produto';
import { simNao } from '../format';
import { CollapsibleSection } from './collapsible-section';
import { Row } from './styles';

interface Props {
  data: ClienteProdutoIntegracoes;
}

const presente = (v: string | null): string => (v ? 'Sim' : 'Não');

export const IntegracoesSection = ({ data }: Props) => (
  <CollapsibleSection
    title="Integrações e pixels"
    testId="produto-section-integracoes"
  >
    <Row>
      <span>Facebook Pixel</span>
      <span>{presente(data.facebookPixel)}</span>
    </Row>
    <Row>
      <span>Facebook Token</span>
      <span>{presente(data.facebookToken)}</span>
    </Row>
    <Row>
      <span>TikTok Pixel</span>
      <span>{presente(data.tikTokPixel)}</span>
    </Row>
    <Row>
      <span>TikTok Token</span>
      <span>{presente(data.tikTokToken)}</span>
    </Row>
    <Row>
      <span>VTurb habilitado</span>
      <span>{simNao(data.vTurbEnabled)}</span>
    </Row>
    {data.vTurbEnabled && (
      <>
        <Row>
          <span>VTurb Account ID</span>
          <span>{data.vTurbAccountId ?? '—'}</span>
        </Row>
        <Row>
          <span>VTurb Video ID</span>
          <span>{data.vTurbVideoId ?? '—'}</span>
        </Row>
        <Row>
          <span>VTurb encaminha eventos</span>
          <span>{simNao(data.vTurbForwardEvents)}</span>
        </Row>
      </>
    )}
  </CollapsibleSection>
);
